import { jsx as _jsx } from "react/jsx-runtime";
import CustomSegmentedTabs from '../_common/tabs/segmentedTabs';
export default function TabsCarType(_a) {
    var activeTabCarType = _a.activeTabCarType, setActiveTabCarType = _a.setActiveTabCarType;
    var handleClickTabCarType = function (title, tabsName) {
        setActiveTabCarType(title);
    };
    var tabsCarType = [
        { defaultValue: "Sedan", handleClick: function () { return handleClickTabCarType('Sedan', 'tabsCarType'); }, id: "1", title: 'Sedan', value: 0, widthTab: '33.3%' },
        { defaultValue: "Suv", handleClick: function () { return handleClickTabCarType('Suv', 'tabsCarType'); }, id: "2", title: 'Suv', value: 1, widthTab: '33.3%' },
        { defaultValue: "Moto", handleClick: function () { return handleClickTabCarType('Moto', 'tabsCarType'); }, id: "3", title: 'Moto', value: 2, widthTab: '33.3%' }
    ];
    return (_jsx(CustomSegmentedTabs, { tabsData: tabsCarType, heightTab: "50px", widthTabs: '550px', activeTab: activeTabCarType, tabsName: 'tabsCarType' }));
}
